import React from "react";
import { Container, ContainerButton, Logo } from "./styles";
import Prefeitura from "../../../../Assets/prefeitura.png"
import Cartorio from "../../../../Assets/aprovado.png"
import { useNavigate } from "react-router";
import { app_base_url } from "../../../../Utils/baseUrl";
export const Default =()=>{
    const navigate = useNavigate();
    return <Container>
        <ContainerButton onClick={()=>{
            navigate(`${app_base_url}/cartorio`)
        }}>
            Cartório
            <Logo src={Cartorio}/>
            </ContainerButton>    


            <ContainerButton  onClick={()=>{
            navigate(`${app_base_url}/prefeitura`)
        }}>
            PREFEITURA
            <Logo src={Prefeitura}/>
            </ContainerButton>   
    </Container>
}